import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export default function Samples() {
  const [samples, setSamples] = useState([]);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api.get("/samples").then((r) => setSamples(r.data)).catch(() => {});
  }, []);

  const inds = ["All", ...new Set(samples.map((s) => s.industry))];
  const shown = filter === "All" ? samples : samples.filter((s) => s.industry === filter);

  return (
    <div className="bg-black">
      <div className="container-x section">
        <div className="text-center mb-12">
          <div className="eyebrow mb-3">Sample Library</div>
          <h1 className="font-heading text-4xl md:text-5xl mb-3">Hear What We've Built</h1>
          <p className="text-white/65">Filter by industry and listen to real Songniture productions.</p>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-3 mb-10">
          {inds.map((i) => (
            <button
              key={i}
              onClick={() => setFilter(i)}
              data-testid={`samples-filter-${i.replace(/\s|&/g, "_")}`}
              className={`px-5 py-2 text-[11px] tracking-[0.22em] uppercase font-semibold border transition ${
                filter === i ? "bg-gold text-black border-gold" : "border-gold/40 text-white/80 hover:border-gold hover:text-gold"
              }`}
            >
              {i}
            </button>
          ))}
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {shown.map((s) => (
            <div key={s.id} className="card overflow-hidden flex flex-col" data-testid={`samples-item-${s.id}`}>
              <div className="aspect-[16/10] relative overflow-hidden">
                <img src={s.image_url} alt={s.title} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent" />
                <div className="absolute top-3 left-3 text-[10px] tracking-[0.25em] uppercase text-gold bg-black/70 border border-gold/40 px-2 py-1">
                  {s.industry}
                </div>
              </div>
              <div className="p-5 flex flex-col gap-3">
                <h3 className="font-heading text-lg">{s.title}</h3>
                <p className="text-white/60 text-sm">{s.description}</p>
                <audio controls preload="none" src={s.audio_url} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
